export default __webpack_public_path__ + "static/media/logoCentrocor.31a8e85e.webp";